/**
 * `me` slice — the canonical home for the logged-in user's identity, populated
 * from `/api/me` (the cross-client source of truth: web SPA + iOS both consume
 * the same payload). Replaces the legacy server-injected `loggedUser` global as
 * the source for user-kind on the web shell's critical path.
 *
 * `loaded` starts false so consumers can apply default-deny: nothing staff-only
 * is shown until `/me` has actually confirmed the user-type.
 */
const initialState = {
  userType: null, // 'Internal' | 'External' | null (unknown / not yet loaded)
  permissions: {
    canCreateCompany: false,
    canCreateProject: false,
    canViewAdminReports: false,
    canExportAccounts: false,
  },
  projects: [],
  loaded: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_ME': {
      const me = action.me || {};
      return {
        ...state,
        userType: me.userType ?? null,
        permissions: me.permissions ?? state.permissions,
        projects: Array.isArray(me.projects) ? me.projects : state.projects,
        loaded: true,
      };
    }
    default:
      return state;
  }
}
